import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { connect } from '../../Store';
import { Icon, Loader } from 'oxyrion-ui/lib';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: ${rem(15)};
  width: 100%;
  ${({ theme }) => theme.media.m`
  width: ${rem(200)}
`};
`;

const YearWrapper = styled.div`
  border: 1px solid #8d8d8d;
  height: ${rem(40)};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${rem(22)};
`;

const RightWrapper = styled.div`
  background-color: ${props =>
    props.disabled ? ({ theme }) => theme.color.disabled : 'none'};
  display: flex;
  align-items: center;
  cursor: ${props => (props.disabled ? 'not-allowed ' : 'pointer')};
  justify-content: center;
  border: 1px solid #8d8d8d;
  height: ${rem(40)};
  min-width: ${rem(40)};
  width: ${rem(40)};
  margin-left: ${rem(7)};
`;

const LeftWrapper = styled.div`
  background-color: ${props =>
    props.disabled ? ({ theme }) => theme.color.disabled : 'none'};
  display: flex;
  cursor: ${props => (props.disabled ? 'not-allowed ' : 'pointer')};
  align-items: center;
  justify-content: center;
  border: 1px solid #8d8d8d;
  height: ${rem(40)};
  width: ${rem(40)};
  min-width: ${rem(40)};
  margin-right: ${rem(7)};
`;

class YearsSlider extends React.Component {
  render() {
    const { selectedYear, onClick, loading } = this.props;
    return (
      <Wrapper>
        <LeftWrapper onClick={() => onClick('left')} disabled={loading}>
          <Icon name="arrow-left" size="l" color="#8d8d8d" />
        </LeftWrapper>
        <YearWrapper>{loading ? <Loader /> : selectedYear}</YearWrapper>
        <RightWrapper
          disabled={selectedYear === new Date().getFullYear() || loading}
          onClick={() => onClick('right')}
        >
          <Icon name="arrow-right" size="l" color="#8d8d8d" />
        </RightWrapper>
      </Wrapper>
    );
  }
}

YearsSlider.propTypes = {
  selectedYear: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
};

YearsSlider.defaultProps = {
  selectedYear: new Date().getFullYear(),
  loading: false,
  onClick: () => {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(YearsSlider);



// WEBPACK FOOTER //
// ./src/Components/YearsSlider/index.jsx